import { Action } from '@ngrx/store';
import { NotificationsState } from '../reducers/notifications';

export enum ActionTypes {
  UpdateNotifications = '[Notifications] Update Notifications',
  MarkAllSeen = '[Notifications] Mark All Seen',
  MarkUnitRoomSeen = '[Notifications] Mark Unit Room Seen',
  AppendNotification = '[Notifications] Append Notification',
  UpdateSelectedApplicationUnread = '[Notifications] Update Selected Application Unread',
}

export class UpdateNotifications implements Action {
  readonly type = ActionTypes.UpdateNotifications;
  constructor(public payload: {}) {}
}

export class MarkAllSeen implements Action {
  readonly type = ActionTypes.MarkAllSeen;
}

export class AppendNotification implements Action {
  readonly type = ActionTypes.AppendNotification;

  constructor(public payload: {}) {}
}
export class MarkUnitRoomSeen implements Action {
  readonly type = ActionTypes.MarkUnitRoomSeen;

  constructor(public payload: number) {}
}

export class UpdateSelectedApplicationUnread implements Action {
  readonly type = ActionTypes.UpdateSelectedApplicationUnread;

  constructor(public payload: number) {}
}
export type NotificationsActions =
  | UpdateNotifications
  | MarkAllSeen
  | MarkUnitRoomSeen
  | UpdateSelectedApplicationUnread;
